import { DragData } from './dragDataUtil';

/**
 * Schema used to store todo items drag and drop data.
 */
export interface TodoItemDragData extends DragData {
    /**
     * Additional information about the task item
     */
    itemData: {
        /**
         * Task subject (e.g. "Buy groceries")
         */
        subject: string;

        /**
         * Task ID (server GUID, or else local ID if `isLocalTask` is set to true)
         */
        taskId: string;
    } & TodoItemDragTelemetryData;
}

/** Log on item drop initiated */
export const TODO_ITEM_DRAG_DATAPOINT_NAME = 'todoItemActionDragToCalendar';
/** Log on item drop failed */
export const TODO_ITEM_DRAG_ERROR_DATAPOINT_NAME = 'todoItemActionDragToCalendarError';

export function getTodoItemDragTelemetryData(
    dragData: TodoItemDragData
): TodoItemDragTelemetryData {
    const telemetryData: TodoItemDragTelemetryData = {};
    const { itemData } = dragData;
    telemetryData.listType = itemData.listType;
    telemetryData.isLocalTask = itemData.isLocalTask;
    telemetryData.nudgeTime = itemData.nudgeTime;
    return telemetryData;
}

/**
 * Schema used to store todo items drag and drop data.
 */
export interface TodoItemDragTelemetryData {
    /**
     * Schema is defined here:
     * https://alexanderplatz.visualstudio.com/To-Do/_git/to-do-telemetry?path=%2Ftelemetry_client_events.json&version=GBmaster&line=775&lineEnd=775&lineStartColumn=9&lineEndColumn=250&lineStyle=plain&_a=contents
     *
     * Used only for telemetry in OPX scenarios. Not populated in OWA code
     */
    listType?: string;

    /**
     * Whether task has only been created locally (i.e. doesn't exist on server yet)
     *
     * Used only for telemetry in OPX scenarios. Not populated in OWA code
     */
    isLocalTask?: boolean;

    /**
     * Indicates the time that the user was nudged to block time for a task (ISO-8601 string)
     *
     * Used only for telemetry in OPX scenarios. Not populated in OWA code
     */
    nudgeTime?: string;
}
